import React from 'react';
import './ServiceCard.scss';

const ServiceCard = ({ image, title, description, imageAlt, reverse = false }) => {
    return (
        <div className={`service-card ${reverse ? 'reverse' : ''}`}>
            <div className="service-card__image">
                <img src={image} alt={imageAlt || title} />
            </div>
            <div className="service-card__content">
                <h3 className="service-card__title">{title}</h3>
                <p className="service-card__description">{description}</p>
            </div>
        </div>
    );
};

export default ServiceCard;